"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Alipay = _interopRequireDefault(require("@rsuite/icon-font/lib/platform/Alipay"));

// Generated by script, don't edit it please.
var Alipay = (0, _createSvgIcon["default"])({
  as: _Alipay["default"],
  ariaLabel: 'alipay',
  category: 'platform',
  displayName: 'Alipay'
});
var _default = Alipay;
exports["default"] = _default;
module.exports = exports.default;